/*
 * @Author: your name
 * @Date: 2021-02-17 16:52:52
 * @LastEditTime: 2022-11-10 10:13:44
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/modules/app.js
 */
// Deep copy a copy of data
// 深度 copy 一份数据
const cloneDeep = (data) => {
  return JSON.parse(JSON.stringify(data))
}

const initAppState = {
  showLoading: false,
  // paymentSurcharge
  paymentSurcharge: '',
  paymentSurchargeSettings: '',
  // merchantFee
  merchantFee: '',
  // 附加费的判定依据：get-venue 的 settings.surcharges 原样 + 门店时区。建单那一刻按它重判费率
  // （utils/surchargeSnapshot.js）。换店时 resetAppState 显式清掉它（不靠这里的键顺序）。
  surchargeSource: null,
  // color
  color: {
    menu_primary_background_colour: '',
    menu_header_background_colour: '',
    menu_header_colour: '',
    menu_primary_text_colour: '',
  },
  // The queue request in the app.vue
  // 'app.vue' 中的 venue 请求
  request: false,
  allowCounterPay: false,
  counterPayName: 'Pay at counter',
  hasOrderInfoInCardDetailPage: false,
  isOnline: false,
  onlineDisabledButton: false, // Take away system, disable the submission buttons such as adding shopping cart for goods   // 外卖系统，禁用 '商品添加购物车' 等的提交按钮
  menuType: 'normal', // Menu Display Type   // 菜单的显示类型
  currentVenueTime: '', // Current time of the restaurant   // 餐厅当前时间

  // Component loading state
  // 组件加载状态
  componentsLoading: false,
  loadedComponents: new Set(),
  componentLoadErrors: []
}

const module_ = {
  state: cloneDeep(initAppState),

  mutations: {
    // Initialize state
    // 初始化 state
    resetAppState(state) {
      // 附加费判定依据与快照换店必须清，显式清（review 第 1 轮 #14）：下面的循环遇到 isOnline 就 return，
      // 排在它后面的键都清不到，以前是靠 surchargeSource 恰好排在前面。
      state.surchargeSource = null
      state.paymentSurcharge = ''
      state.paymentSurchargeSettings = ''
      state.merchantFee = ''
      for (var i in initAppState) {
        // Do not initialize isOnline
        // 不初始化 isOnline
        if (i === 'isOnline') return
        state[i] = initAppState[i]
      }
    },
    // Enable Loading
    // 开启 Loading
    showLoading(state) {
      state.showLoading = true
    },

    // Close Loading
    // 关闭 Loading
    closeLoading(state) {
      state.showLoading = false
    },

    // 保存支付 paymentSurcharge
    savePaymentSurcharge(state, paymentSurcharge) {
      state.paymentSurcharge = paymentSurcharge
    },

    savePaymentSurchargeSettings(state, paymentSurchargeSettings) {
      state.paymentSurchargeSettings = paymentSurchargeSettings
    },

    // 登记附加费判定依据 { surcharges, timeZone }
    saveSurchargeSource(state, surchargeSource) {
      state.surchargeSource = surchargeSource
    },

    // Save the merchantFee
    // 保存 merchantFee
    saveMerchantFee(state, merchantFee) {
      state.merchantFee = merchantFee
    },

    // Save theme color
    // 保存主题 color
    saveColor(state, {
      prop,
      val
    }) {
      state.color[prop] = val
    },

    // Save the request result as an app Request queue result in vue
    // 保存 request result 是 'app.vue' 中的请求 venue 的结果
    // Function: app After the end of the API request in the vue, request other APIs
    // 作用：'app.vue' 中的 API 请求结束后，再去请求其他 API
    saveRequestResult(state, status) {
      state.request = status
    },

    // Allow counterPay for saving
    // 保存是否允许 counterPay 的结果
    saveAllowCounterPay(state, res) {
      state.allowCounterPay = res
    },

    saveCounterPayName(state, res) {
      state.counterPayName = res
    },

    // Save whether there is order information on the card detail page
    // 保存是否有 order 信息在 card-detail 页面的结果
    saveHasOrderInfoInCardDetailPage(state, res) {
      state.hasOrderInfoInCardDetailPage = res
    },

    saveIsOnline(state, isOnline) {
      state.isOnline = isOnline
    },

    saveOnlineDisabledButton(state, onlineDisabledButton) {
      state.onlineDisabledButton = onlineDisabledButton
    },

    // Save menuType
    // 保存 menuType
    saveMenuType(state, menuType) {
      state.menuType = menuType
    },

    // Save current time
    // 保存当前时间
    saveCurrentVenueTime(state, currentVenueTime) {
      state.currentVenueTime = currentVenueTime
    },

    // Component loading mutations
    // 组件加载相关 mutations
    SET_COMPONENTS_LOADING(state, loading) {
      state.componentsLoading = loading
    },

    ADD_LOADED_COMPONENT(state, componentName) {
      state.loadedComponents.add(componentName)
    },

    ADD_COMPONENT_LOAD_ERROR(state, error) {
      state.componentLoadErrors.push({
        error,
        timestamp: new Date().toISOString()
      })
    },

    CLEAR_COMPONENT_ERRORS(state) {
      state.componentLoadErrors = []
    }
  },
  actions: {
    async ensureComponentsLoaded({ state, commit }, components) {
      if (!Array.isArray(components)) {
        components = [components]
      }

      const unloadedComponents = components.filter(
        comp => !state.loadedComponents.has(comp)
      )

      if (unloadedComponents.length === 0) {
        return true
      }

      commit('SET_COMPONENTS_LOADING', true)

      try {
        // Import componentLoader dynamically to avoid circular dependency
        const { default: componentLoader } = await import('@/utils/componentLoader')

        // Wait for components to load
        await componentLoader.waitForComponents(unloadedComponents)

        // Mark as loaded
        unloadedComponents.forEach(comp => {
          commit('ADD_LOADED_COMPONENT', comp)
        })

        commit('SET_COMPONENTS_LOADING', false)
        return true
      } catch (error) {
        commit('ADD_COMPONENT_LOAD_ERROR', error)
        commit('SET_COMPONENTS_LOADING', false)
        return false
      }
    }
  },
  getters: {
    isComponentLoaded: (state) => (componentName) => {
      return state.loadedComponents.has(componentName)
    },

    areAllComponentsLoaded: (state) => (components) => {
      return components.every(comp => state.loadedComponents.has(comp))
    },

    hasComponentLoadErrors: (state) => {
      return state.componentLoadErrors.length > 0
    }
  }
}

export default module_
